export const STORAGE_PATHS = {
	DECLARATIONS: {
		DECLARATION_OF_AVAILABILITY: 'deklaracje/deklaracja_dostepnosci.pdf'
	},
	PRIVACY_POLICY: 'polityka_prywatnosci/mobile_apps.pdf'
};
